// Generated by scripts/localization/render_web.py. No account or inventory storage.
const spanish = {
  "Overview": "Resumen",
  "Devices": "Dispositivos",
  "Alerts": "Alertas",
  "Agents": "Agentes",
  "Account": "Cuenta",
  "Help": "Ayuda",
  "SEE WHAT'S ON YOUR NETWORK": "DESCUBRE QUÉ HAY EN TU RED",
  "Help center": "Centro de ayuda",
  "Scan this network.": "Explora esta red.",
  "Find responding devices on your private Wi-Fi, including phones, TVs, printers and computers. No account or agent is needed. Results stay on this phone; quiet or isolated devices may not appear.": "Encuentra dispositivos que respondan en tu wifi privada, como teléfonos, televisores, impresoras y computadoras. No necesitas una cuenta ni un agente. Los resultados permanecen en este teléfono; los dispositivos inactivos o aislados pueden no aparecer.",
  "Scanning…": "Explorando…",
  "Scan this network": "Explorar esta red",
  "Uses limited connection checks on the selected Wi-Fi. No cellular or VPN scanning. It never disconnects, blocks, or changes a device. Scan only networks you're allowed to.": "Realiza comprobaciones limitadas de conexión en la wifi seleccionada. No explora redes móviles ni VPN. Nunca desconecta, bloquea ni modifica un dispositivo. Explora solo redes para las que tengas permiso.",
  "HAVE A SENTINEL DEPLOYMENT?": "¿YA TIENES UN SERVICIO SENTINEL?",
  "Connect to your authorized Sentinel service for continuous monitoring, agent coverage, alert history, and multi-network inventory.": "Conéctate a tu servicio Sentinel autorizado para consultar la supervisión continua, la cobertura de los agentes, el historial de alertas y el inventario de varias redes.",
  "Sentinel access key": "Clave de acceso de Sentinel",
  "The raw key is exchanged once for a short-lived session. Only the session token is encrypted with Android Keystore.": "La clave original se intercambia una vez por una sesión de corta duración. Solo el token de sesión se cifra con Android Keystore.",
  "Open secure console": "Abrir consola segura",
  "Explore synthetic preview": "Explorar vista previa de ejemplo",
  "Connect with an access key": "Conectar con una clave de acceso",
  "Use only on networks and Sentinel servers you are authorized to monitor.": "Úsalo solo en redes y servidores Sentinel que tengas autorización para supervisar.",
  "This network": "Esta red",
  "Done": "Listo",
  "SCANNING": "EXPLORANDO",
  "Checked {0} of {1} addresses — {2} devices so far": "Se comprobaron {0} de {1} direcciones; {2} dispositivos hasta ahora",
  "Reading the network and looking for devices…": "Leyendo la red y buscando dispositivos…",
  "Devices found": "Dispositivos encontrados",
  "Addresses checked": "Direcciones comprobadas",
  "Scan again": "Explorar de nuevo",
  "No devices answered. Some networks isolate clients from each other, which hides other devices from any scanner.": "Ningún dispositivo respondió. Algunas redes aíslan a sus clientes entre sí, lo que impide que cualquier explorador vea otros dispositivos.",
  "WHAT THIS SCAN CAN AND CANNOT SEE": "QUÉ PUEDE VER ESTA EXPLORACIÓN",
  "Limited TCP checks find responding devices on the selected private Wi-Fi. Large networks are narrowed to the displayed /20 or smaller subnet around this phone (at most 4,094 addresses). Network-bound mDNS naming is available on Android 13 and later. Android does not expose hardware addresses to this app. Quiet or isolated devices may not appear, and device types are estimates. This app never changes a device.": "Las comprobaciones TCP limitadas encuentran dispositivos que responden en la wifi privada seleccionada. Las redes grandes se limitan a la subred /20 o menor que aparece alrededor de este teléfono, con un máximo de 4,094 direcciones. Los nombres mDNS de la red están disponibles desde Android 13. Android no proporciona direcciones de hardware a esta aplicación. Los dispositivos inactivos o aislados pueden no aparecer y los tipos de dispositivo son estimaciones. Esta aplicación nunca modifica un dispositivo.",
  "ROUTER": "ROUTER",
  "THIS PHONE": "ESTE TELÉFONO",
  "Advertises: {0}": "Nombres anunciados: {0}",
  "Open services: {0}": "Servicios disponibles: {0}",
  "Hostname: {0}": "Nombre de host: {0}",
  "Seen via: {0}": "Detectado mediante: {0}",
  "network response": "respuesta de la red",
  "SYNTHETIC PREVIEW": "VISTA PREVIA DE EJEMPLO",
  "{0} SESSION": "SESIÓN: {0}",
  "ONLINE": "EN LÍNEA",
  "OFFLINE": "SIN CONEXIÓN",
  "Network overview": "Resumen de la red",
  "Refresh": "Actualizar",
  "Online": "En línea",
  "Unknown": "Desconocido",
  "Open alerts": "Alertas pendientes",
  "Baselining": "Aprendizaje inicial",
  "VISIBILITY, NOT ENFORCEMENT": "OBSERVACIÓN SIN BLOQUEO",
  "Sentinel observes. It does not block.": "Sentinel observa. No bloquea.",
  "Router adapters are read-only. The app cannot disconnect, quarantine, deauthenticate, or intercept a device.": "Los adaptadores de router son de solo lectura. La aplicación no puede desconectar, aislar, desautenticar ni interceptar un dispositivo.",
  "PRIVACY BOUNDARY": "ALCANCE DE LA PRIVACIDAD",
  "This app requests inventory, agent health, and alerts from your authenticated Sentinel API. Session tokens remain Keystore-encrypted. No analytics SDK is included.": "Esta aplicación solicita el inventario, el estado de los agentes y las alertas a tu API de Sentinel autenticada. Los tokens de sesión permanecen cifrados con Keystore. No incluye un SDK de analíticas.",
  "Server visibility rules are authoritative.": "Se aplican las reglas de visibilidad del servidor.",
  "Search name, IP, MAC, or vendor": "Buscar nombre, IP, MAC o fabricante",
  "All": "Todos",
  "Watch": "Vigilar",
  "No devices match this view.": "Ningún dispositivo coincide con esta vista.",
  "No current IP": "Sin IP actual",
  "{0} / {1} confidence": "{0} / confianza {1}",
  "Label": "Etiqueta",
  "Type": "Tipo",
  "Owner": "Propietario",
  "Room": "Habitación",
  "Trust": "Confianza",
  "Recent join sessions": "Conexiones recientes",
  "No join sessions recorded.": "No hay conexiones registradas.",
  "{0} / {1}: {2} to {3}": "{0} / {1}: de {2} a {3}",
  "still joined": "sigue conectado",
  "This session is read-only. Operator or higher is required to edit.": "Esta sesión es de solo lectura. Para editar se requiere el rol Operador o uno superior.",
  "Save": "Guardar",
  "Close": "Cerrar",
  "Recent alerts": "Alertas recientes",
  "Acknowledgement changes workflow state; it does not block a device.": "Confirmar una alerta cambia su estado de seguimiento; no bloquea un dispositivo.",
  "No alerts reported.": "No hay alertas registradas.",
  "Acknowledge": "Confirmar",
  "OPEN": "PENDIENTE",
  "ACK": "CONFIRMADA",
  "Monitoring agents": "Agentes de supervisión",
  "Coverage is limited to the network segments each authorized agent can observe.": "La cobertura se limita a los segmentos de red que cada agente autorizado puede observar.",
  "No monitoring agents reported.": "No hay agentes de supervisión registrados.",
  "{0} observations / last {1}": "{0} observaciones / última: {1}",
  "Baselining until {0}": "Aprendizaje inicial hasta {0}",
  "Session and alerts": "Sesión y alertas",
  "ACCESS ROLE": "ROL DE ACCESO",
  "Local synthetic preview. No server token exists.": "Vista previa local de ejemplo. No hay ningún token del servidor.",
  "Session expiry: {0}": "La sesión vence: {0}",
  "The long-lived access key is never stored. The short-lived token is AES-256-GCM encrypted with a non-exportable Android Keystore key.": "La clave de acceso de larga duración nunca se guarda. El token de corta duración se cifra con AES-256-GCM mediante una clave de Android Keystore que no se puede exportar.",
  "NATIVE PUSH": "ALERTAS DE ANDROID",
  "Firebase client configuration is not present in this build.": "Esta versión no incluye la configuración del cliente de Firebase.",
  "Native Sentinel alerts are enabled.": "Las alertas de Sentinel en Android están activadas.",
  "Native Sentinel alerts are available.": "Las alertas de Sentinel en Android están disponibles.",
  "Disable native alerts": "Desactivar alertas nativas",
  "Enable native alerts": "Activar alertas nativas",
  "Refresh workspace": "Actualizar espacio de trabajo",
  "Export inventory PDF": "Exportar inventario a PDF",
  "Android app settings": "Ajustes de la app en Android",
  "Exit preview": "Salir de la vista previa",
  "Lock and log out": "Bloquear y cerrar sesión",
  "Local scans, connected monitoring and full policies. All topics can be read offline.": "Exploraciones locales, supervisión conectada y políticas completas. Todos los temas se pueden leer sin conexión.",
  "Search all help topics": "Buscar en todos los temas de ayuda",
  "START WITH YOUR FEATURE": "ELIGE UNA FUNCIÓN",
  "Run a local Wi-Fi scan": "Explorar una red wifi local",
  "Connect to your Sentinel deployment": "Conectar con tu servicio Sentinel",
  "Manage native alerts": "Gestionar alertas nativas",
  "Export and protect a report": "Exportar y proteger un informe",
  "Read privacy policy offline": "Leer política de privacidad sin conexión",
  "Read terms of use offline": "Leer términos de uso sin conexión",
  "Support and troubleshooting": "Soporte y solución de problemas",
  "Not reported": "Sin datos",
  "Checking service": "Comprobando el servicio",
  "Join a private Wi-Fi network with VPN turned off, then scan.": "Conéctate a una red wifi privada con la VPN desactivada y vuelve a explorar.",
  "The scan could not complete.": "No se pudo completar la exploración.",
  "Saved session expired or was revoked. Enter an access key again.": "La sesión guardada venció o fue revocada. Introduce de nuevo una clave de acceso.",
  "The saved session could not be checked. It has been kept; reconnect and reopen the app.": "No se pudo comprobar la sesión guardada. Se ha conservado; vuelve a conectarte y abre de nuevo la aplicación.",
  "Unable to open Sentinel.": "No se pudo abrir Sentinel.",
  "Synthetic local preview": "Demostración ficticia local",
  "Synthetic records never contact the monitoring API.": "Los registros ficticios nunca se conectan a la API de supervisión.",
  "Device updated.": "Dispositivo actualizado.",
  "Alert acknowledged.": "Alerta confirmada.",
  "Push is not configured in this build.": "Las notificaciones no están configuradas en esta versión.",
  "Native Sentinel alerts enabled.": "Alertas de Sentinel en Android activadas.",
  "Native Sentinel alerts disabled.": "Alertas de Sentinel en Android desactivadas.",
  "Alerts are disabled on this device. Server removal could not be confirmed; reconnect and try again.": "Las alertas están desactivadas en este dispositivo. No se pudo confirmar su eliminación del servidor; vuelve a conectarte e inténtalo de nuevo.",
  "Choose where to save the report.": "Elige dónde guardar el informe.",
  "The report is no longer available. Export it again.": "El informe ya no está disponible. Expórtalo de nuevo.",
  "Could not open the selected destination.": "No se pudo abrir el destino seleccionado.",
  "Report saved to your chosen location.": "Informe guardado en la ubicación elegida.",
  "The report could not be saved. Please try another destination.": "No se pudo guardar el informe. Prueba otro destino.",
  "Sentinel request failed.": "La solicitud a Sentinel falló.",
  "Service online": "Servicio en línea",
  "Service not ready": "El servicio no está listo",
  "Service unavailable": "Servicio no disponible",
  "Access key must contain at least 32 characters.": "La clave de acceso debe tener al menos 32 caracteres.",
  "The server did not return a session token.": "El servidor no devolvió un token de sesión.",
  "Only HTTPS connections are allowed.": "Solo se permiten conexiones HTTPS.",
  "Unexpected redirect from Sentinel.": "Redirección inesperada de Sentinel.",
  "Sentinel returned status {0}.": "Sentinel devolvió el estado {0}.",
  "Sentinel response exceeded the safe size limit.": "La respuesta de Sentinel superó el límite de tamaño seguro.",
  "The Sentinel session expired or was revoked.": "La sesión de Sentinel venció o fue revocada.",
  "Sentinel alerts": "Alertas de Sentinel",
  "Authorized network monitoring alerts": "Alertas de supervisión de redes autorizadas",
  "A monitored network event needs review.": "Un evento de una red supervisada necesita revisión.",
  "The Wi-Fi network changed. Join the intended network and scan again.": "La red wifi cambió. Conéctate a la red deseada y vuelve a explorar.",
  "No network": "Sin red",
  "Router / gateway": "Router / puerta de enlace",
  "This phone": "Este teléfono",
  "IPP printing": "Impresión IPP",
  "Raw printing": "Impresión directa",
  "Remote desktop": "Escritorio remoto",
  "Port {0}": "Puerto {0}",
  "Router": "Router",
  "Printer": "Impresora",
  "TV / streaming": "Televisor / contenido multimedia",
  "Camera": "Cámara",
  "Speaker": "Altavoz",
  "Storage": "Almacenamiento",
  "Phone": "Teléfono",
  "Computer": "Computadora",
  "Media server": "Servidor multimedia",
  "Computer / appliance": "Computadora / equipo de red",
  "Unknown device": "Dispositivo desconocido",
  "Administrator": "Administrador",
  "Operator": "Operador",
  "Read-only": "Solo lectura",
  "A new device joined the demo network.": "Un nuevo dispositivo se conectó a la red de demostración.",
  "The watched demo printer returned.": "La impresora de demostración supervisada volvió a conectarse.",
  "Change language": "Cambiar idioma",
  "phone": "teléfono",
  "computer": "computadora",
  "printer": "impresora",
  "television": "televisor",
  "camera": "cámara",
  "speaker": "altavoz",
  "router": "router",
  "game-console": "consola de videojuegos",
  "iot": "IoT",
  "unknown": "desconocido",
  "trusted": "de confianza",
  "important": "importante",
  "watch": "vigilar",
  "guest": "invitado",
  "ignored": "ignorado",
  "blocked": "bloqueado",
  "low": "baja",
  "medium": "media",
  "high": "alta",
  "new-device": "Nuevo dispositivo conectado",
  "device-returned": "Dispositivo de vuelta",
  "device-missing": "dispositivo ausente",
  "agent-offline": "Agente de supervisión sin conexión",
  "reachable": "respuesta de red",
  "this-device": "este dispositivo",
  "Original event: {0}": "Evento original: {0}",
  "important-device-offline": "Dispositivo importante sin conexión",
  "Synthetic preview": "Vista previa de ejemplo",
  "Offline": "Sin conexión",
  "Privacy policy": "Política de privacidad",
  "Terms of use": "Términos de uso",
  "Prototype ready": "Prototipo disponible",
  "Agent integration": "Integración con agentes",
  "Planned": "Previsto",
  "Trusted": "De confianza",
  "Guest": "Invitado",
  "Rogue printer demonstration": "Demostración de una impresora no autorizada",
  "Advertise one temporary assessment printer, accept the first client-approved job, and close the capture window immediately.": "Anuncia una impresora temporal de evaluación, acepta el primer trabajo aprobado por el cliente y cierra inmediatamente el periodo de captura.",
  "One job · local encrypted evidence · client-controlled deletion": "Un trabajo · pruebas locales cifradas · eliminación controlada por el cliente",
  "2 minutes": "2 minutos",
  "Workplace look-alike SSID": "SSID similar al de la empresa",
  "Measure whether a user voluntarily joins an authorized look-alike network without deauthentication or forced roaming.": "Evalúa si un usuario se conecta voluntariamente a una red similar autorizada, sin forzar desconexiones ni cambios de red.",
  "Association behavior · captive-portal outcome · no Wi-Fi key capture": "Comportamiento de conexión · resultado del portal cautivo · sin capturar claves de Wi-Fi",
  "Credential-entry behavior": "Comportamiento al introducir credenciales",
  "Present a client-approved generic login prompt and record only whether fields were populated and submitted.": "Presenta un formulario genérico de acceso aprobado por el cliente y registra únicamente si se rellenaron y enviaron los campos.",
  "Boolean-only evidence · typed values never leave the browser": "Pruebas de sí o no · los valores escritos nunca salen del navegador",
  "Traffic intelligence profile": "Perfil de metadatos del tráfico",
  "Summarize visible DNS, HTTP and TLS destination metadata and identify likely business-critical login services.": "Resume los metadatos visibles de destinos DNS, HTTP y TLS e identifica posibles servicios de acceso esenciales para la empresa.",
  "Metadata-first · payload retention disabled by default": "Prioridad a los metadatos · conservación del contenido desactivada de forma predeterminada",
  "Scoped window": "Periodo autorizado",
  "Reception printer": "Impresora de recepción",
  "Now": "Ahora",
  "Conference TV": "Televisión de la sala de reuniones",
  "Former guest phone": "Teléfono de un invitado anterior",
  "192.168.10.87 · Private MAC": "192.168.10.87 · MAC privada",
  "Manufacturer hidden": "Fabricante oculto",
  "1 min ago": "Hace 1 min",
  "Unidentified device": "Dispositivo sin identificar",
  "Just joined": "Recién conectado",
  "Immediate join alerts": "Alertas de nuevas conexiones",
  "Identity with evidence": "Identidad basada en observaciones",
  "Combine hostnames, advertised services, IEEE manufacturer assignments and user labels without overstating uncertain matches.": "Combina nombres de host, servicios anunciados, asignaciones IEEE de fabricantes y etiquetas del usuario sin exagerar las coincidencias inciertas.",
  "Network history": "Historial de red",
  "Track first seen, last seen, online sessions, IP changes and the evidence source behind every observation.": "Consulta la primera y última observación, las sesiones en línea, los cambios de IP y la fuente de cada observación.",
  "Coverage you can trust": "Cobertura con límites claros",
  "Clearly show which network segments the appliance can observe and when router integration or an additional sensor is required.": "Muestra claramente qué segmentos de red puede observar el equipo y cuándo se necesita integración con el router o un sensor adicional.",
  "Skip to content": "Ir al contenido",
  "Sentinel home": "Inicio de Sentinel",
  "by Auto Secure Login": "de Auto Secure Login",
  "Toggle navigation": "Mostrar u ocultar navegación",
  "Monitoring": "Supervisión",
  "Live console": "Consola en vivo",
  "Rapid assessment": "Evaluación rápida",
  "Appliance": "Equipo",
  "Safety": "Uso seguro",
  "ASL home": "Inicio de ASL",
  "Request an assessment": "Solicitar una evaluación",
  "Network visibility + authorized security validation": "Visibilidad de red y validación de seguridad autorizada",
  "Get it on Google Play": "Disponible en Google Play",
  "$9.99 one time": "$9.99 en un solo pago",
  "Know what joined.": "Conoce qué se conectó.",
  "Prove what could be exploited.": "Comprueba las posibles exposiciones.",
  "Explore rapid assessment": "Explorar la evaluación rápida",
  "See network monitoring": "Ver la supervisión de red",
  "Sentinel platform highlights": "Funciones destacadas de Sentinel",
  "New-device push alerts": "Alertas de dispositivos nuevos",
  "Manufacturer matching": "Identificación de fabricantes",
  "Signed assessment scope": "Alcance de evaluación firmado",
  "Illustrative Sentinel network map": "Mapa de red ilustrativo de Sentinel",
  "Observing": "Observando",
  "Gateway observer": "Observador de la puerta de enlace",
  "Hunter’s phone": "Teléfono de Hunter",
  "Office printer": "Impresora de oficina",
  "New device": "Dispositivo nuevo",
  "Workstation 07": "Estación de trabajo 07",
  "Watched": "Vigilado",
  "NEW DEVICE DETECTED": "NUEVO DISPOSITIVO DETECTADO",
  "Espressif device joined Staff Wi-Fi": "Un dispositivo Espressif se conectó al Wi-Fi del personal",
  "192.168.10.116 · 8 seconds ago": "192.168.10.116 · hace 8 segundos",
  "Open illustrative alert": "Abrir alerta ilustrativa",
  "known": "conocidos",
  "online": "en línea",
  "unreviewed": "sin revisar",
  "agent health": "estado del agente",
  "Sentinel deployment principles": "Principios de instalación de Sentinel",
  "Raspberry Pi 5 first": "Primero Raspberry Pi 5",
  "Native Linux agent": "Agente nativo para Linux",
  "Android + PWA": "Android y PWA",
  "One responsive console": "Una consola adaptable",
  "Evidence controlled": "Pruebas bajo control",
  "Local by default": "Local de forma predeterminada",
  "Fast deployment": "Instalación rápida",
  "Minimal client setup": "Configuración mínima del cliente",
  "Continuous network watch": "Supervisión continua de la red",
  "Every visible device, explained and remembered.": "Cada dispositivo visible, explicado y registrado.",
  "The always-on agent builds a durable inventory, identifies devices from multiple signals and opens a new session only when a device genuinely returns—so alerts remain useful instead of noisy.": "El agente continuo crea un inventario persistente, identifica dispositivos mediante varias señales y abre una sesión nueva cuando un dispositivo vuelve a conectarse, para reducir las alertas repetidas.",
  "DEVICE INVENTORY": "INVENTARIO DE DISPOSITIVOS",
  "Staff network": "Red del personal",
  "Live": "En vivo",
  "Inventory display options": "Opciones de visualización del inventario",
  "Observed": "Observados",
  "Online now": "En línea ahora",
  "Unreviewed": "Sin revisar",
  "Illustrative device inventory": "Inventario de dispositivos ilustrativo",
  "Device": "Dispositivo",
  "Manufacturer": "Fabricante",
  "Policy": "Clasificación",
  "Seen": "Visto",
  "Illustrative data. Production results show the evidence source and confidence behind each identity.": "Datos ilustrativos. Los resultados reales muestran la fuente de observación y el nivel de confianza de cada identidad.",
  "Authorized rapid assessment": "Evaluación rápida autorizada",
  "Turn an abstract warning into a result the client can see.": "Convierte una advertencia abstracta en un resultado visible para el cliente.",
  "Connect the appliance, verify the signed engagement, run an automatic preflight and demonstrate approved exposure using the client’s own selected workstation and unimportant test material.": "Conecta el equipo, verifica el acuerdo firmado, ejecuta la comprobación previa y demuestra la exposición aprobada con una estación elegida por el cliente y material de prueba sin importancia.",
  "Rapid assessment workflow": "Pasos de la evaluación rápida",
  "Connect": "Conectar",
  "One network cable and private operator control": "Un cable de red y control privado del operador",
  "Preflight": "Comprobación previa",
  "Scope, interface and automatic cleanup verified": "Alcance, interfaz y limpieza automática verificados",
  "Demonstrate": "Demostrar",
  "Short, bounded client-approved scenario": "Escenario breve, limitado y aprobado por el cliente",
  "Prove": "Comprobar",
  "Finding, remediation and repeatable retest": "Hallazgo, corrección y prueba repetible",
  "Preview scenario": "Ver escenario de ejemplo",
  "Raspberry Pi 5 prototype": "Prototipo Raspberry Pi 5",
  "A field appliance built to arrive ready.": "Un equipo de campo diseñado para llegar preparado.",
  "Native services": "Servicios nativos",
  "No Docker or virtual machine required": "Sin necesidad de Docker ni máquinas virtuales",
  "Offline-capable scope": "Alcance disponible sin conexión",
  "Signed engagement rules remain enforceable without cloud access": "Las reglas firmadas del acuerdo siguen aplicándose sin acceso a la nube",
  "Local evidence custody": "Custodia local de las pruebas",
  "Client documents stay on the appliance by default": "Los documentos del cliente permanecen en el equipo de forma predeterminada",
  "Automatic cleanup": "Limpieza automática",
  "Every active scenario has an expiry and stop path": "Cada escenario activo tiene caducidad y una forma de detenerse",
  "Discuss a pilot assessment": "Consultar sobre una evaluación piloto",
  "Raspberry Pi 5 Sentinel appliance architecture": "Arquitectura del equipo Sentinel Raspberry Pi 5",
  "SENTINEL / PI5": "SENTINEL / PI5",
  "FIELD PROTOTYPE": "PROTOTIPO DE CAMPO",
  "Native Go agent": "Agente nativo Go",
  "Scope": "Alcance",
  "VERIFIED": "VERIFICADO",
  "Evidence": "Pruebas",
  "LOCAL": "LOCAL",
  "Expiry": "Caducidad",
  "ARMED": "PREPARADO",
  "Client LAN": "LAN del cliente",
  "Discovery + authorized tests": "Descubrimiento y pruebas autorizadas",
  "Operator console": "Consola del operador",
  "Android + installable PWA": "Android y PWA instalable",
  "ASL backend": "Servicio ASL",
  "Operator console preview": "Vista previa de la consola del operador",
  "One place to verify scope, run the timer and stop immediately.": "Un lugar para verificar el alcance, iniciar el temporizador y detenerse de inmediato.",
  "Console preview navigation": "Navegación de la consola de ejemplo",
  "Network map": "Mapa de red",
  "Assessments": "Evaluaciones",
  "Prototype console": "Consola del prototipo",
  "RAPID ASSESSMENT": "EVALUACIÓN RÁPIDA",
  "Authorized scenario console": "Consola de escenarios autorizados",
  "Scope manifest": "Documento de alcance",
  "Verified": "Verificado",
  "Enabled": "Activado",
  "Raw credentials": "Credenciales originales",
  "Prohibited": "Prohibidas",
  "Deauthentication": "Desconexión forzada",
  "Disabled": "Desactivada",
  "SCENARIO ARMED": "ESCENARIO PREPARADO",
  "READY FOR PREFLIGHT": "LISTO PARA LA COMPROBACIÓN PREVIA",
  "Select a scenario above to preview the operator flow": "Selecciona un escenario arriba para ver los pasos del operador",
  "Interface preview only. No appliance command or network action is being issued.": "Solo es una vista previa de la interfaz. No se envían comandos al equipo ni se realizan acciones de red.",
  "Active tests require a paired appliance and signed engagement scope.": "Las pruebas activas requieren un equipo vinculado y un alcance de trabajo firmado.",
  "Automatic stop": "Parada automática",
  "Emergency stop": "Parada de emergencia",
  "Scenario time remaining": "Tiempo restante del escenario",
  "Live evidence stream": "Secuencia de pruebas",
  "Preview data": "Datos de ejemplo",
  "Scope signature verified": "Firma del alcance verificada",
  "Scenario permissions and expiry checked locally": "Permisos y caducidad del escenario comprobados localmente",
  "Evidence policy loaded": "Política de pruebas cargada",
  "Cloud document upload disabled": "Subida de documentos a la nube desactivada",
  "Scenario timer running": "Temporizador del escenario en marcha",
  "Awaiting authorized scenario": "Esperando un escenario autorizado",
  "Automatic stop remains active": "La parada automática sigue activa",
  "No active collection or redirection": "Sin recopilación ni redirección activa",
  "Designed for authorized use": "Diseñado para un uso autorizado",
  "The boundary is part of the product.": "Los límites forman parte del producto.",
  "Sentinel’s assessment edition is built to demonstrate exposure without becoming an unrestricted interception toolkit. The backend signs the scope; the appliance enforces it again locally.": "La edición de evaluación de Sentinel está diseñada para demostrar exposiciones dentro de un alcance autorizado. El servicio firma el alcance y el equipo vuelve a aplicarlo localmente.",
  "Read ASL’s security approach": "Conocer el enfoque de seguridad de ASL",
  "Exact scope": "Alcance preciso",
  "Approved scenario, interface, network, endpoint and expiration are signed before execution.": "El escenario, la interfaz, la red, el dispositivo y la caducidad aprobados se firman antes de la ejecución.",
  "Hard stop paths": "Mecanismos de parada",
  "Timer expiry, local emergency stop and cleanup rules terminate active services.": "La caducidad del temporizador, la parada local de emergencia y las reglas de limpieza finalizan los servicios activos.",
  "Minimal evidence": "Pruebas mínimas",
  "Credential simulations retain behavior—not typed passwords, MFA codes, cookies or tokens.": "Las simulaciones de credenciales conservan el comportamiento, sin guardar contraseñas escritas, códigos MFA, cookies ni tokens.",
  "Client-controlled custody": "Custodia controlada por el cliente",
  "Printed test documents remain encrypted on the appliance and are deleted under the selected policy.": "Los documentos de prueba impresos permanecen cifrados en el equipo y se eliminan según la política seleccionada.",
  "Sentinel pilot program": "Programa piloto de Sentinel",
  "See the devices. Demonstrate the risk. Prove the fix.": "Conoce los dispositivos. Demuestra el riesgo. Comprueba la solución.",
  "Discuss a Raspberry Pi 5 pilot, a home-network monitor or an authorized rapid assessment for your organization.": "Consulta sobre un piloto de Raspberry Pi 5, un monitor de red doméstica o una evaluación rápida autorizada para tu organización.",
  "Contact Auto Secure Login": "Contactar con Auto Secure Login",
  "Install Sentinel PWA": "Instalar la PWA de Sentinel",
  "Network visibility and authorized security validation, beginning with a Raspberry Pi 5 field appliance.": "Visibilidad de red y validación de seguridad autorizada, con un prototipo de equipo de campo Raspberry Pi 5.",
  "Help and policies": "Ayuda y políticas",
  "Platform": "Plataforma",
  "Main website": "Sitio principal",
  "Security": "Seguridad",
  "Contact": "Contacto",
  "ASL LLC. Denver, Colorado.": "ASL LLC. Denver, Colorado.",
  "Authorized assessment use only · Prototype availability varies": "Solo para evaluaciones autorizadas · La disponibilidad del prototipo varía",
  "The console is locked.": "La consola está bloqueada.",
  "The session was not accepted.": "La sesión no fue aceptada.",
  "Refreshing…": "Actualizando…",
  "Scanning local network…": "Explorando la red local…",
  "Connected": "Conectado",
  "Connection failed": "Error de conexión",
  "Unable to refresh Sentinel.": "No se pudo actualizar Sentinel.",
  "The administrator key was not accepted.": "La clave del administrador no fue aceptada.",
  "The server returned no session.": "El servidor no devolvió una sesión.",
  "Unable to reach Sentinel.": "No se pudo conectar con Sentinel.",
  "Not connected": "Sin conexión",
  "Watch / guest": "Vigilados / invitados",
  "Agents online": "Agentes en línea",
  "No IP": "Sin IP",
  "private MAC": "MAC privada",
  "Private/randomized MAC": "MAC privada o aleatoria",
  "Manufacturer not provided": "Fabricante no indicado",
  "Manufacturer not found": "Fabricante no encontrado",
  "Advertised identity": "Identidad anunciada",
  "MAC manufacturer": "Fabricante según la MAC",
  "Last observed": "Última observación",
  "Offline since": "Sin conexión desde",
  "Edit": "Editar",
  "Details": "Detalles",
  "No alerts recorded.": "No hay alertas registradas.",
  "Acknowledged": "Confirmada",
  "No monitoring agent has reported yet.": "Todavía no ha informado ningún agente de supervisión.",
  "no sources recorded": "sin fuentes registradas",
  "No join sessions recorded yet.": "Todavía no hay sesiones de conexión registradas.",
  "Unable to save the device.": "No se pudo guardar el dispositivo.",
  "Unable to acknowledge alert.": "No se pudo confirmar la alerta.",
  "Re-enter the Sentinel administrator key to enable background alerts:": "Vuelve a introducir la clave del administrador de Sentinel para activar las alertas en segundo plano:",
  "Background alerts enabled": "Alertas en segundo plano activadas",
  "Enable alerts": "Activar alertas",
  "Unable to change background alerts.": "No se pudieron cambiar las alertas en segundo plano.",
  "Notifications unsupported": "Notificaciones no compatibles",
  "Alerts enabled": "Alertas activadas",
  "Windows protects the stored Sentinel key; alerts continue from the system tray.": "Windows protege la clave de Sentinel guardada; las alertas continúan desde la bandeja del sistema.",
  "Windows secure credential storage is unavailable.": "El almacenamiento seguro de credenciales de Windows no está disponible.",
  "New device joined": "Se conectó un dispositivo nuevo",
  "Watched device returned": "Volvió un dispositivo vigilado",
  "Important device offline": "Dispositivo importante sin conexión",
  "Monitoring agent offline": "Agente de supervisión sin conexión",
  "Sentinel alert": "Alerta de Sentinel",
  "at an unknown time": "a una hora desconocida",
  "Enter the complete administrator key.": "Introduce la clave completa del administrador.",
  "ASL Network Sentinel home": "Inicio de ASL Network Sentinel",
  "by ASL": "de ASL",
  "Network Sentinel RF Suite": "Suite de radiofrecuencia de Network Sentinel",
  "Network Sentinel RF suite": "Suite de radiofrecuencia de Network Sentinel",
  "Network Console": "Consola de red",
  "RF Hardware": "Equipos de radiofrecuencia",
  "Lock console": "Bloquear consola",
  "Private operator console": "Consola privada del operador",
  "See every device Sentinel can observe.": "Conoce los dispositivos que Sentinel puede observar.",
  "Enter an access key provisioned by your Sentinel administrator. It is exchanged for a short-lived session in this browser tab. Your assigned role controls whether you can edit devices or acknowledge alerts.": "Introduce una clave de acceso proporcionada por tu administrador de Sentinel. Se intercambia por una sesión de corta duración en esta pestaña. Tu rol determina si puedes editar dispositivos o confirmar alertas.",
  "Open console": "Abrir consola",
  "Live network visibility": "Visibilidad de la red en vivo",
  "Loading the latest observations…": "Cargando las últimas observaciones…",
  "Refresh now": "Actualizar ahora",
  "Network summary": "Resumen de la red",
  "Inventory": "Inventario",
  "Search devices": "Buscar dispositivos",
  "Search name, IP or vendor": "Buscar nombre, IP o fabricante",
  "Filter devices": "Filtrar dispositivos",
  "All devices": "Todos los dispositivos",
  "Watch and guest": "Vigilados e invitados",
  "Important": "Importantes",
  "Attention": "Atención",
  "Coverage": "Cobertura",
  "Device identity": "Identidad del dispositivo",
  "Edit device": "Editar dispositivo",
  "Device label": "Etiqueta del dispositivo",
  "Living room TV": "Televisión de la sala",
  "Device type": "Tipo de dispositivo",
  "Automatic detection": "Detección automática",
  "Television / streaming device": "Televisión / dispositivo de reproducción",
  "Camera / doorbell": "Cámara / timbre",
  "Speaker / voice assistant": "Altavoz / asistente de voz",
  "Router / access point": "Router / punto de acceso",
  "Game console": "Consola de videojuegos",
  "Smart-home / IoT device": "Dispositivo domótico / IoT",
  "Household": "Hogar",
  "Living room": "Sala",
  "Observed activity": "Actividad observada",
  "Monitoring policy": "Clasificación de supervisión",
  "Unreviewed — alert on return": "Sin revisar — alertar al volver",
  "Trusted — normal monitoring": "De confianza — supervisión normal",
  "Important — alert if offline": "Importante — alertar si se desconecta",
  "Watch — alert every return": "Vigilar — alertar cada vez que vuelva",
  "Guest — alert every return": "Invitado — alertar cada vez que vuelva",
  "Ignored — retain without alerts": "Ignorado — conservar sin alertas",
  "Blocked — policy label only until router integration": "Bloqueado — solo una etiqueta hasta la integración con el router",
  "Save changes": "Guardar cambios",
  "Network Sentinel Console | ASL": "Consola Network Sentinel | ASL",
  "edited": "editado",
  "high confidence": "confianza alta",
  "medium confidence": "confianza media",
  "low confidence": "confianza baja",
  "info": "información",
  "warning": "advertencia",
  "Request failed with HTTP {0}.": "La solicitud falló con HTTP {0}.",
  "Local scan found {0} devices. Loading inventory…": "La exploración local encontró {0} dispositivos. Cargando inventario…",
  "Updated {0} · automatic refresh every 15 seconds": "Actualizado {0} · actualización automática cada 15 segundos",
  "{0} · detected as {1}": "{0} · detectado como {1}",
  "{0} · {1} · last report {2}": "{0} · {1} · último informe {2}",
  "{0} observation(s) via {1}.": "{0} observaciones mediante {1}.",
  "Names seen: {0}": "Nombres observados: {0}",
  "{0} ({1}) — {2} to {3}": "{0} ({1}) — de {2} a {3}",
  "Unknown {0}": "Desconocido {0}",
  "Unable to complete the request. Check your connection and service access.": "No se pudo completar la solicitud. Comprueba la conexión y tu acceso al servicio.",
  "checking": "comprobando",
  "offline": "sin conexión",
  "Receive Android push alerts or, while the web console is open, browser notifications when a new, watched or guest device starts a fresh network session.": "Recibe una notificación de Android o, con la consola web abierta, del navegador cuando un dispositivo nuevo, vigilado o invitado inicia una nueva sesión de red.",
  "Sentinel combines continuous device monitoring with a Raspberry Pi 5 rapid-assessment prototype to help make network risk understandable.": "Sentinel combina la supervisión continua de dispositivos con un prototipo de evaluación rápida basado en Raspberry Pi 5 para ayudar a comprender los riesgos de la red.",
  "The appliance prototype uses a Raspberry Pi 5, native Go services and local encrypted storage. Appliance control integration is separate from the monitoring and local-scan features available in the current Android app.": "El prototipo de equipo utiliza Raspberry Pi 5, servicios nativos Go y almacenamiento local cifrado. La integración del control del equipo es independiente de las funciones de supervisión y exploración local de la aplicación Android.",
  "This website includes an interface preview and performs no network actions. Live appliance features require separate integration, signed scope and an authorized operating window.": "Este sitio incluye una vista previa de la interfaz. No ejecuta acciones de red. Las funciones reales del equipo requieren una integración independiente, un alcance firmado y un periodo autorizado.",
  "SENTINEL / ILLUSTRATIVE NETWORK": "SENTINEL / RED DE EJEMPLO",
  "ILLUSTRATIVE APPLIANCE ONLINE": "EQUIPO DE EJEMPLO EN LÍNEA",
  "Language": "Idioma",
  "Cancel": "Cancelar",
  "Unable to download the inventory report.": "No se pudo descargar el informe del inventario.",
  "baseliningAgents": "Agentes en aprendizaje inicial",
  "Security & RF": "Seguridad y RF",
  "All ASL products": "Todos los productos ASL",
  "Tools": "Herramientas",
  "Reference": "Referencia",
  "Hardware & setup": "Hardware y configuración",
  "Band reference": "Referencia de bandas",
  "Product overview": "Información del producto",
  "Network Sentinel on this page": "Network Sentinel en esta página"
};
let current = 'en';
try {
  const requested = new URL(location.href).searchParams.get('lang');
  const stored = localStorage.getItem('sentinel-language');
  current = requested === 'en' || requested === 'es' ? requested : stored === 'en' || stored === 'es' ? stored : navigator.language?.startsWith('es') ? 'es' : 'en';
} catch {}
if (typeof document !== 'undefined') document.documentElement.lang = current;
export function sourceText(value) { return Object.entries(spanish).find(([,translated]) => translated === value)?.[0] ?? value; }
export function getLanguage() { return current; }
export function t(english, ...values) {
  const template = current === 'es' ? spanish[english] ?? english : english;
  return String(template).replace(/\{(\d+)\}/g, (match, index) => values[Number(index)] === undefined ? match : String(values[Number(index)]));
}
export function localizedError(error) {
  const message = error instanceof Error ? error.message : String(error ?? '');
  if (current === 'en' || Object.hasOwn(spanish, message)) return t(message);
  const http = /^Request failed with HTTP (\d+)\.$/.exec(message);
  return http ? t('Request failed with HTTP {0}.', http[1]) : t('Unable to complete the request. Check your connection and service access.');
}
export function setLanguage(value) {
  if (!['en', 'es'].includes(value)) return;
  current = value;
  try { localStorage.setItem('sentinel-language', value); } catch {}
  document.documentElement.lang = value;
  try { const url = new URL(location.href); url.searchParams.set('lang', value); history.replaceState(null, '', url); } catch {}
  window.dispatchEvent(new CustomEvent('sentinel-language-change'));
}
export function localizedPath(path) {
  if (path === '/privacy.html' || path === '/terms.html') return current === 'es' ? '/es' + path : path;
  if (path.startsWith('/help-center/') && !path.startsWith('/help-center/es/')) return current === 'es' ? path.replace('/help-center/', '/help-center/es/') : path;
  if (path === '/' || path === '/monitoring.html') return path + '?lang=' + current;
  return path;
}
/** Register only static nodes present before the console renders API records.
 * No observer or blanket text replacement ever touches user-supplied data.
 */
export function installStaticTranslations(root = document) {
  const texts = [], attributes = [], links = [];
  const walker = document.createTreeWalker(root.documentElement ?? root, NodeFilter.SHOW_TEXT);
  for (let node; (node = walker.nextNode());) {
    if (node.parentElement?.closest('script,style')) continue;
    const original = node.nodeValue;
    const key = original.replace(/\s+/g, ' ').trim();
    if (Object.hasOwn(spanish, key)) texts.push({node,original,key});
  }
  for (const node of root.querySelectorAll('[aria-label],[placeholder],[title]')) {
    for (const name of ['aria-label', 'placeholder', 'title']) {
      const value = node.getAttribute(name);
      if (value && Object.hasOwn(spanish, value)) attributes.push({node,name,value});
    }
  }
  for (const node of root.querySelectorAll('a[href^="/"]')) links.push({node,path:node.getAttribute('href')});
  const apply = () => {
    for (const {node,original,key} of texts) if (node.isConnected) node.nodeValue = current === 'es' ? original.replace(/\S[\s\S]*\S|\S/, t(key)) : original;
    for (const {node,name,value} of attributes) if (node.isConnected) node.setAttribute(name, t(value));
    for (const {node,path} of links) node.setAttribute('href', localizedPath(path));
    for (const node of root.querySelectorAll('[data-language]')) node.setAttribute('aria-pressed', String(node.dataset.language === current));
  };
  for (const node of root.querySelectorAll('[data-language]')) node.addEventListener('click', () => setLanguage(node.dataset.language));
  window.addEventListener('sentinel-language-change', apply);
  apply();
  return () => window.removeEventListener('sentinel-language-change', apply);
}
